(() => {
  const state = window.__afghaniPdpV2Accordion || {};
  window.__afghaniPdpV2Accordion = state;

  const syncAccordionState = () => {
    document.querySelectorAll('#MainContent .accordion__details').forEach((details) => {
      if (details.dataset.afghaniAriaBound === 'true') return;

      const summary = details.querySelector('summary');
      if (!summary) return;

      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      sync();
      details.addEventListener('toggle', sync);
      details.dataset.afghaniAriaBound = 'true';
    });
  };

  state.sync = syncAccordionState;

  const restoreRequiredGiftSelection = () => {
    document
      .querySelectorAll(
        'quantity-breaks .quantity-break__upsell[data-type="gift"][data-product]'
      )
      .forEach((item) => {
        item.dataset.selected = 'true';
      });
  };

  const prepareRequiredGift = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const isOfferChange =
      event.type === 'change' &&
      target?.matches('quantity-breaks input[name="quantity"]');
    const isProductSubmit =
      event.type === 'submit' &&
      target?.matches('form[id^="product-form-"]');

    if (isOfferChange || isProductSubmit) {
      restoreRequiredGiftSelection();
    }
  };

  if (!state.initialized) {
    const syncCurrentState = () => state.sync();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncCurrentState, { once: true });
    }

    document.addEventListener('shopify:section:load', syncCurrentState);
    document.addEventListener('change', prepareRequiredGift, true);
    document.addEventListener('submit', prepareRequiredGift, true);
    state.initialized = true;
  }

  if (document.readyState !== 'loading') {
    state.sync();
  }
})();
